/**
 * Modo demonstracao (spec `tutorial-crm` 6.1-1).
 *
 * A flag `?tutorial=1` e' lida UMA vez, no carregamento deste modulo, e fica
 * numa variavel de modulo: os redirecionamentos do `CrmRouteGate` e do
 * react-router perdem a query string, e o iframe nao pode "sair" do modo
 * demonstracao no meio do caminho. Este arquivo e' importado pelo bundle
 * normal (stores, `services/api.ts`, `socket-manager`), entao fica minimo:
 * nada de import de React, i18n ou store aqui.
 */

export const TUTORIAL_QUERY_PARAM = 'tutorial';
export const TUTORIAL_LANGUAGES = ['pt-BR', 'en-US', 'es-ES'] as const;
export type TutorialLanguage = (typeof TUTORIAL_LANGUAGES)[number];
export type TutorialTheme = 'light' | 'dark';

export interface TutorialParams {
  readonly theme: TutorialTheme;
  readonly lng: TutorialLanguage;
}

const DEFAULT_PARAMS: TutorialParams = { theme: 'light', lng: 'pt-BR' };

export function readTutorialFlag(search: string): boolean {
  return new URLSearchParams(search).get(TUTORIAL_QUERY_PARAM) === '1';
}

function isTutorialLanguage(value: string | null): value is TutorialLanguage {
  return value !== null && (TUTORIAL_LANGUAGES as readonly string[]).includes(value);
}

/** Idioma da sessao real no formato do tutorial (`en` → `en-US`); desconhecido cai no pt-BR. */
export function toTutorialLanguage(language?: string): TutorialLanguage {
  const prefix = (language ?? '').slice(0, 2);
  return TUTORIAL_LANGUAGES.find((lng) => lng.startsWith(prefix)) ?? DEFAULT_PARAMS.lng;
}

/** Tema e idioma da sessao real, repassados pela sobreposicao. Valor invalido cai no padrao. */
export function readTutorialParams(search: string): TutorialParams {
  const query = new URLSearchParams(search);
  const lng = query.get('lng');
  return {
    theme: query.get('theme') === 'dark' ? 'dark' : DEFAULT_PARAMS.theme,
    lng: isTutorialLanguage(lng) ? lng : DEFAULT_PARAMS.lng,
  };
}

/** URL do iframe: a mesma rota, com a query original + `tutorial=1&theme=&lng=`. */
export function buildTutorialUrl(pathname: string, search: string, params: TutorialParams): string {
  const query = new URLSearchParams(search);
  query.set(TUTORIAL_QUERY_PARAM, '1');
  query.set('theme', params.theme);
  query.set('lng', params.lng);
  return `${pathname}?${query.toString()}`;
}

function initialSearch(): string {
  return typeof window === 'undefined' ? '' : window.location.search;
}

const TUTORIAL_MODE = readTutorialFlag(initialSearch());
const TUTORIAL_PARAMS = readTutorialParams(initialSearch());

/** `true` so dentro do iframe do tutorial. */
export function isTutorialMode(): boolean {
  return TUTORIAL_MODE;
}

export function getTutorialParams(): TutorialParams {
  return TUTORIAL_PARAMS;
}
